import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { formatNumber, formatScientificNumber, isScientificNotation } from "../../utils/helper";
import ClipLoaderComponent from "../loader/ClipLoaderComponent";

function ConfirmationTrx({
  setIsClaimModalOpen,
  rewards,
  ClaimReward,
  btnloading,
  key,
}) {
  const [isTotalRewardsToolTipOpen, setIsTotalRewardsToolTipOpen] =
    useState(false);
  const [isTotalCommissionToolTipOpen, setIsTotalCommissionToolTipOpen] =
    useState(false);
  const [isTotalDelegatorRewardToolTipOpen, setIsTotalDelegatorRewardToolTipOpen] =
    useState(false);
  const total_unclaimed_comission = rewards?.total_unclaimed_comission ?? 0;
  const total_unclaimed_rewards = rewards?.total_unclaimed_rewards ?? 0;
  const totalRewards = total_unclaimed_rewards + total_unclaimed_comission;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed top-0 left-0 w-screen h-screen bg-vampireBlack/90 z-50 overflow-y-auto overflow-x-hidden flex"
      >
        <div className="flex items-center justify-center w-full h-auto xsm:h-full px-4 forMobile">
          <motion.div
            initial={{
              opacity: 0,
              scale: 0,
              transition: {
                duration: 0.3,
              },
            }}
            animate={{
              opacity: 1,
              scale: 1,
              transition: {
                duration: 0.3,
                mass: 0.8,
                type: "spring",
              },
            }}
            exit={{
              opacity: 0,
              scale: 0,
              transition: {
                duration: 0.3,
              },
            }}
            className="max-w-[633px] w-full bg-[#010101] border-2 border-primaryWhite/[0.06] rounded-[32px] px-4 py-7 md:px-[103px] md:py-[38px] mx-auto my-5"
          >
            <div className="flex items-center justify-between flex-col gap-3 md:gap-[22px]">
              <span className="w-[50px] h-[50px] md:w-[70px] md:h-[70px] *:w-full *:h-full">
                <img src={`${process.env.REACT_APP_S3_ASSETS_URL}/loading.png`} alt="loading"/>
              </span>
              <h4 className="text-primaryWhite text-xxl md:text-1xl font-semibold -tracking-[1.8px]">
                Hold Tight!
              </h4>
              <p className="text-primaryWhite/[0.74] text-lg/[21px] font-medium -tracking-[0.42px] mb-[9px] text-center">
                Your transaction is syncing up with the chain.
                <span className="block mt-2 text-[14px] text-center">
                  If this pop-up doesn't close automatically, try giving the window a refreshing spin!
                </span>
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default ConfirmationTrx;
